// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"9ea8525c","421":"aabf1c85","459":"903f6498","468":"3d51354c"}[chunkId] + ".chunk.js";
};